module.exports = __webpack_public_path__ + "img/medel.5b2a64a7.jpg";